<template>

  <div class="content-wrap">
    <div class="search-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="회계년도">
              <template #end>
                <DatePicker v-model="state.searchParams.fs_year" :format="state.format" :year-picker="true" 
                      :selectDate="state.searchParams.fs_year"
                      @return="r=>state.searchParams.fs_year = r"/>
              </template>
            </ElLabel>
          </div>
        </div>

        <div class="col-md-3 mb-3">
            <ElLabel name="영업대표">
              <template #end>
                <ElSelect v-model="state.searchParams.sales_ceo" :options="state.ceoList"/>
              </template>
            </ElLabel>
        </div>
      </div>
    </div>

    <div class="search-detail-wrap"></div>
    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="getDataList(); getDataListGM()">검색</ElButton>
    </div>

    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center mb-2">
      </div>
      <div class="table-btn-group d-flex align-items-center">
        <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
        <img src="/images/vr.png" alt="" />
        <span class="rd-won">(단위:원)</span>
      </div>
      
    </div>
    <div class="table-responsive" style="height:45rem">
      <table class="table table-rt table-hover">
        <thead  class="fh-top">
          <tr class="tr-rt2 fh-top">
            <th v-for="col in state.gridColumn" :key="col.field" :class="[col.class ? col.class : '']">{{ col.headerName
              }}</th>
          </tr>
        </thead>
        <tbody>
          <tr :class="[index === state.gridRowDataGMHeader.length - 1 ? 'band bb-2' : 'band']"
            v-for="(hRow, index) in state.gridRowDataGMHeader" :key="index">

            <template v-for="key in headerKey">
              <td :class="getClassNm(hRow,key)">
                <span :class="isNegative(hRow[key])">{{ numberFormat(hRow[key]) || 0 }}</span>
              </td>
            </template>
          </tr>
          <tr v-for="(row, index) in state.gridRowData" :key="index">
            <template v-for="key in headerKey">
              <td :class="getClassNm(row,key)">
                <span :class="isNegative(row[key])">{{ numberFormat(row[key]) || 0 }}</span>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

  <ExcelManage
    ref="excelManageRef"
    v-show="false"/>
    
</template>

<script setup>
import { reactive, onMounted, ref,onBeforeMount } from "vue";
import common from "@/js/common";
import { getLoadUsers } from '@/api/monthly';
import { useLoading } from '@/composable/Loading'
const { setIsLoading } = useLoading()
import { useUserStore } from "@/store/user";
const userStore = useUserStore()
import DatePicker from '@/components/common/DatePicker.vue';
import { getMrGmHeaderList, getMrGmList } from "@/api/monthly";
import ExcelManage    from '@/components/common/MCO_EX_001.vue'

const yearsList = ref([]);
const excelManageRef = ref();
const headerKey = ['classified_nm','jan','feb','mar','q1','apr','may','jun','q2','1h','jul','aug','sep','q3','oct','nov','dec','q4','2h','total']
onBeforeMount(async()=>{
  await getSalesCeo()
  getYearsList();  // fiscal year
  getDataListGM(); // the header of GM first  Grid 
  getDataList();   // data body

});



//천단위 표현식
function numberFormat(data) {
  if (isNaN(data)) return data
  return common.checkNumberComma(Math.round(data))
}

//소수점 두자리 노출
function decimalFormat(data) {
  if (isNaN(Number(data))) return data
  return Number(data).toFixed(1)
}

function getYearsList() {
  const prevYear = new Date().getFullYear() - 3;   // Previous fiscal year  
  const currYear = new Date().getFullYear();    // Previous fiscal year to calculated to consecutive same cal value above current fiscal year variable
  for (let i = currYear; i >= prevYear; i--) {
    yearsList.value = [...yearsList.value, i];  ///yearsList.value.push(i);
  }
  state.searchParams.fs_year = yearsList.value[0];

}


/* 영업대표 목록 */
const getSalesCeo = async () => {
      try {
        setIsLoading(true) 
        state.ceoList = []

        //사용자 목록을 영업대표{text, value} 목록으로 변환
        if(['ADMIN', 'E'].includes(userStore.user.authGrpId)){
          const res = await getLoadUsers({employee_id : userStore.user.employeeId,auth_grp_id : userStore.user.authGrpId})
          state.ceoList.push({ text: '전체', value: '' })
          res.rtn.forEach(user => {
            state.ceoList.push({ text: user.user_nm, value: user.employee_id })
          })
          state.searchParams.sales_ceo = state.ceoList[0].value
        }else{
          state.ceoList.push({ text: userStore.user.userNm, value: userStore.user.employeeId })
          state.searchParams.sales_ceo = userStore.user.employeeId
        }
       
      } catch (err) {
        console.error(err);
        alert("영업대표 초기화 에러가 발생하였습니다.");
      } finally {
        setIsLoading(false)
      }
};


// 조회건  
async function getDataListGM() {

  state.gridRowDataGMHeader = []

  let params = {
    fs_year: state.searchParams.fs_year,
    employee_id: state.searchParams.sales_ceo,
  };
  try {
    setIsLoading(true)
    const res = await getMrGmHeaderList(params)
    state.gridRowDataGMHeader = [...res.rtn].map((item) => {

      headerKey.filter((data2) => data2 !== 'classified_nm').forEach((key) => {
        if(item.classified_nm.includes('%')){
          if(!item[key]) item[key] = 0
          item[key] = `${decimalFormat(item[key])}%`
        }else{
          if(!item[key]) item[key] = 0
        }
      })
      return item

    })
  } catch (err) {
    console.error(err)
    alert('조회 에러');
  } finally {
    setIsLoading(false)
  }
};





// 매출액 조회건 (2번째 그리드 역역) 
async function getDataList() {

  let params = {
    fs_year: state.searchParams.fs_year,
    employee_id: state.searchParams.sales_ceo,
  };

  let getMrGmRowData = [];
  state.gridRowData = []
  try {
    setIsLoading(true)
    const res = await getMrGmList(params)
    getMrGmRowData = res.rtn

    let saleTaxSummary = { classified_nm: '총 매출액' }
    let purchaseTaxSummary = { classified_nm: '총 매입액' }
    let collectSummary = { classified_nm: '총 수금액' }
    let paymentsSummary = { classified_nm: '총 지급액' }

    let colPayDiff = [{ classified_nm: '수금(Y)-지급(Y)	' }, { classified_nm: '수금(N)-지급(N)' }]
    let colPayDiffSum = { classified_nm: '수금(Y,N)-지급(Y,N)' }

    getMrGmRowData.forEach((data) => {
      switch (data.classified_cd) {
        case 'sales_tax':
          state.gridColumn.map((col) => col.field).filter((item) => item !== 'classified_nm').forEach((key) => {
            if (!saleTaxSummary[key]) saleTaxSummary[key] = 0
            saleTaxSummary[key] = isNaN(Number(data[key])) ? saleTaxSummary[key] : saleTaxSummary[key] + Number(data[key])
          })
          break
        case 'purchase_tax':
          state.gridColumn.map((col) => col.field).filter((item) => item !== 'classified_nm').forEach((key) => {
            if (!purchaseTaxSummary[key]) purchaseTaxSummary[key] = 0
            purchaseTaxSummary[key] = isNaN(Number(data[key])) ? purchaseTaxSummary[key] : purchaseTaxSummary[key] + Number(data[key])
          })
          break

        case 'collect':
          state.gridColumn.map((col) => col.field).filter((item) => item !== 'classified_nm').forEach((key) => {
            if (!collectSummary[key]) collectSummary[key] = 0
            collectSummary[key] = isNaN(Number(data[key])) ? collectSummary[key] : collectSummary[key] + Number(data[key])

            if (data.classified_nm.includes('Y')) {
              if (!colPayDiff[0][key]) colPayDiff[0][key] = 0
              colPayDiff[0][key] += Number(data[key])
            } else {
              if (!colPayDiff[1][key]) colPayDiff[1][key] = 0
              colPayDiff[1][key] += Number(data[key])
            }

            if (!colPayDiffSum[key]) colPayDiffSum[key] = 0
            colPayDiffSum[key] = isNaN(Number(data[key])) ? colPayDiffSum[key] : colPayDiffSum[key] + Number(data[key])

          })
          break

        case 'Payments':
          state.gridColumn.map((col) => col.field).filter((item) => item !== 'classified_nm').forEach((key) => {
            if (!paymentsSummary[key]) paymentsSummary[key] = 0
            paymentsSummary[key] = isNaN(Number(data[key])) ? paymentsSummary[key] : paymentsSummary[key] + Number(data[key])

            //수금(Y)-지급(Y)
            if (data.classified_nm.includes('Y')) {
              if (!colPayDiff[0][key]) colPayDiff[0][key] = 0
              colPayDiff[0][key] -= Number(data[key])
            } else {
              //수금(N)-지급(N)
              if (!colPayDiff[1][key]) colPayDiff[1][key] = 0
              colPayDiff[1][key] -= Number(data[key])
            }
            if (!colPayDiffSum[key]) colPayDiffSum[key] = 0
            colPayDiffSum[key] = isNaN(Number(data[key])) ? colPayDiffSum[key] : colPayDiffSum[key] - Number(data[key])

          })
          break
      }
    })


    let saleTaxList = [...getMrGmRowData.filter((item) => item.classified_cd === 'sales_tax')]
    if(saleTaxList.length === 0) {
      saleTaxList = [{classified_cd : 'sales_tax',classified_nm : '매출세금계산서(Y)'},{classified_cd : 'sales_tax',classified_nm : '매출세금계산서(N)'}]
    }

    let purchaseTaxList = [...getMrGmRowData.filter((item) => item.classified_cd === 'purchase_tax')]
    if(purchaseTaxList.length === 0) {purchaseTaxList = [{classified_cd : 'purchase_tax',classified_nm : '매입세금계산서(Y)'},{classified_cd : 'purchase_tax',classified_nm : '매입세금계산서(N)'}]}

    let collectList = [...getMrGmRowData.filter((item) => item.classified_cd === 'collect')]
    if(collectList.length === 0) {collectList = [{classified_cd : 'collect',classified_nm : '수금(Y)'},{classified_cd : 'collect',classified_nm : '수금(N)'}]}

    let paymentsList = [...getMrGmRowData.filter((item) => item.classified_cd === 'Payments')]
    if(paymentsList.length === 0) {paymentsList = [{classified_cd : 'Payments',classified_nm : '지급(Y)'},{classified_cd : 'Payments',classified_nm : '지급(N)'}]}

    state.gridRowData = [
      ...saleTaxList,
      { ...saleTaxSummary, class: 'sum' },
      ...purchaseTaxList,
      { ...purchaseTaxSummary, class: 'sum' },
      ...collectList,
      { ...collectSummary, class: 'sum' },
      ...paymentsList,
      { ...paymentsSummary, class: 'sum' },
      ...colPayDiff,
      { ...colPayDiffSum, class: 'sum' },
    ].map((item)=>{
      headerKey.filter((header)=>header!='headerKey').forEach((key)=>{
        if(!item[key]) item[key] = 0
      })
      return item
    })
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }

};



const state = reactive({
  ceoList : [],
  stake_id: '',
  selectedRow: [],
  gridColumn: [
    { headerName: "구분", field: "classified_nm", class: 'table-item' },
    { headerName: "Jan", field: "jan" },
    { headerName: "Feb", field: "feb" },
    { headerName: "Mar", field: "mar" },
    { headerName: "Q1", field: "q1", class: 'tt' },
    { headerName: "Apr", field: "apr" },
    { headerName: "May", field: "may" },
    { headerName: "Jun", field: "jun" },
    { headerName: "Q2", field: "q2", class: 'tt' },
    { headerName: "1H", field: "1h", class: 'ht' },
    { headerName: "Jul", field: "jul" },
    { headerName: "Aug", field: "aug" },
    { headerName: "Sep", field: "sep" },
    { headerName: "Q3", field: "q3", class: 'tt' },
    { headerName: "Oct", field: "oct" },
    { headerName: "Nov", field: "nov" },
    { headerName: "Dec", field: "dec" },
    { headerName: "Q4", field: "q4", class: 'tt' },
    { headerName: "2H", field: "2h", class: 'ht' },
    { headerName: "Total", field: "total", class: 'tt' },

  ],
  gridRowDataGMHeader: [],
  gridRowData: [],

  searchParams: {
    fs_year: '',       // 회계년도  
    users_name: '',
    employee_id: null,
    sales_ceo : ''
  },

  format:'yyyy'

});

function excelDown(){
  let fileNm = 'Monthly Revenue & Gross Margin'
  let header = [...state.gridColumn]
  let dataList = [...state.gridRowDataGMHeader,...state.gridRowData]
  excelManageRef.value.excelDownload(fileNm,header,dataList)
}


function isNegative(data){
  if(!data || isNaN(data)) return
  data = data.toString().replaceAll('%','')

  if(Number(data) < 0){
    return 'text-b-rt'
  }
}
function getClassNm(data,key){
  if(key === 'classified_nm' && data?.class === 'sum'){
    return'sum table-item text-start'
  }else if(key === 'classified_nm'){
    return'table-item'
  }else{
    
    if(['q1','q2','q3','q4'].includes(key)){
      return `${data.class} tt`
    }else if(['1h','2h'].includes(key)){
      return `${data.class} ht`
    }else if(key === 'total'){
      return `tt ${data.class}`
    }else{
      return data.class
    }
  }
}
</script>

<style></style>